import useAccountApi from '~/services/apis/account'
import { TimeOut } from '~/services/apis/timeout'

export default defineNuxtPlugin({
	name: 'auth-verify',
	parallel: true,
	async setup() {
		const { cookie, storage, accountInfo } = useAuth()
		const { isLoggedIn } = reactor(useUser())
		const { fetchCompanySupport } = useStore()
		const { GetAccountInfo } = useAccountApi()
		const { fetchPermissions } = usePermissionStore()
		if (
			(!isLoggedIn.value && cookie.value && isOverAnHour(storage.value?.lastSavedAt)) ||
			(cookie.value && !storage.value?.lastSavedAt)
		) {
			GetAccountInfo()
		}
		TimeOut().then(() => {
			Promise.all([fetchPermissions(accountInfo.value?.id ?? ''), fetchCompanySupport()])
		})
	}
})
